<template>
    <div class="box">
        <div class="top">
            <div class="left">
                <template>
                    <img src="../../assets/images/login3.png" />
                </template>
            </div>
            <div class="right">
                <div class="btn"><img src="../../assets/images/edit.png" @click="logout" /><span>退出</span></div>
                <div class="btn btn2"><img src="../../assets/images/password.png" @click="editPass" /><span>修改密码</span></div>
                <!-- <div><img :src="!fullscreen?require('../../assets/images/qp.png'):require('../../assets/images/qp2.png')" @click="screenFull" /></div> -->
                <div class="line"></div>
                <div class="tet">
                    <img v-if="yhimgurl" :src="yhimgurl" />
                    <img v-else src="../../assets/images/userImg.png" />
                    <p>
                        <span>{{ xm }}</span>
                        <label>{{ jcjg }}</label>
                    </p>
                </div>
            </div>
        </div>
        <div class="nav nav2" :style="{'width':isCollapse ? '64px' : '220px'}">
            <el-scrollbar  ref="myScrollbar">            
                <el-menu :unique-opened="true" ref="menu"
                    :default-active="dqActive"
                    class="el-menu-vertical-demo"
                    @open="handleOpen"
                    @close="handleCloseC"
                    @select="handleSelect"
                    :collapse="isCollapse" style="margin-top:10px;">
                    <div style="display:none;"><i class="ico el-icon-data-line" style="font-size:20px;margin: 15px 12px 0 28px;"></i><a class="navA" @click="navigateToHome" target="_blank">展示页</a></div>
                    <div v-for="(item,index) in menu" :key="index" >
                        <el-menu-item v-if="!item.children" :index="item.index" @click="clickMenu2()" :class="$route.path == '/index' ? 'is-active' : ''">
                            <i class="ico"></i>
                            <span slot="title">&nbsp;{{item.label}}</span>
                        </el-menu-item>
                        
                        <el-submenu v-else-if="item.children && item.show" :index="item.index" :class="(dqActive!=0 && dqActive.split('-')[0] === item.index)  ? 'is-active' : ''">
                            <template slot="title">
                            <i class="ico"></i>
                            <span>&nbsp;{{item.label}}</span>
                            </template> 
                            
                            <el-menu-item  v-for="(itema,i) in item.children" :key="i" :index="itema.index" @click="clickMenu(item,itema)" :class="$route.path == itema.path ? 'is-active2' : ''">
                                <p v-if="itema.show && itema.ck == 1">
                                {{ itema.label }}
                                </p>
                            </el-menu-item>
                        
                        </el-submenu>
                    </div>
                </el-menu>
            </el-scrollbar>
        </div>
        <div class="main" :style="{'left':isCollapse ? '64px' : '220px'}">
            <div class="tags">
                <el-radio-group v-model="isCollapse" style="margin-bottom: 20px; float: left;">
                    <el-radio-button v-show="isCollapse" :label="false"><img src="../../assets/images/left.png" /></el-radio-button>
                    <el-radio-button v-show="!isCollapse" :label="true"><img src="../../assets/images/right.png" /></el-radio-button>
                </el-radio-group>
                <el-tag 
                    v-for="(tag,index) in tags" :key="tag.path" 
                    size="small"
                    :closable="tag.label != '首页'"
                    :type="$route.path === tag.path ? '' : 'info'"
                    :effect="$route.path === tag.path ? 'dark' : 'plain'"
                    @click="changeMenu(tag)"
                    @close="handleClose(tag,index)"
                    >
                        {{ tag.label }}
                </el-tag>
            </div>
            <div class="mainContent">
                <router-view></router-view>
            </div>
        </div> 
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'

    export default {
        name: "Layout",
        data() {
            return {
                xianqu:'',
                cmid: '',
                xm:'',
                jcjg:'',
                yhimgurl:'',
                isCollapse: false,
                qxList:[],
                menu:[],
                menu3:[
                    {
                       "index":'0',
                        "path":"/index", 
                        "label": "首页",
                        "url": "index",
                        "show":true,
                    },
                    {
                        "id":'9',
                        "index":'9',
                        "path":"", 
                        "label": "任务管理",
                        "url": "",
                        "show":true,
                        children:[
                            {
                                "index":'9-1',
                                "path":"/fbrw", 
                                "label": "发布任务",
                                "url": "fbrw",
                                "show":true
                            },
                            {
                                "index":'9-2',
                                "path":"/rwzx", 
                                "label": "任务管理",
                                "url": "rwzx",
                                "show":true
                            },
                            {
                                "index":'9-4',
                                "path":"/rwsh", 
                                "label": "审核管理",
                                "url": "rwsh",
                                "show":true
                            }
                        ]
                    }
                ],
                menu4:[
                    {
                       "index":'0',
                        "path":"/index", 
                        "label": "首页",
                        "url": "index",
                        "show":true,
                        "ck":1,
                    },
                    {
                        "id":'4',
                        "index":'4',
                        "path":"/ahpc", 
                        "label": "案后评查",
                        "url": "ahpc",
                        "show":true,
                        "ck":1,
                        children:[
                            {
                                "index":'4-1',
                                "path":"/pcaj", 
                                "label": "案卷智能解析",
                                "url": "pcaj",
                                "show":true
                            },
                            {
                                "index":'4-2',
                                "path":"/ajpc", 
                                "label": "案卷电子评查",
                                "url": "ajpc",
                                "show":true
                            },
                            //{
                            //   "index":'4-3',
                            //    "path":"/ajsc", 
                            //    "label": "案卷上传列表",
                            //    "url": "ajsc",
                            //    "show":true
                            //}
                        ]
                    },
                    {
                        "id":'5',
                        "index":'5',
                        "path":"/dzda", 
                        "label": "电子档案管理",
                        "url": "dzda",
                        "show":true,
                        "ck":1,
                        children:[
                            {
                                "index":'5-1',
                                "path":"/dzdak", 
                                "label": "电子档案库",
                                "url": "dzdak",
                                "show":true
                            },
                            {
                                "index":'5-2',
                                "path":"/daxq", 
                                "label": "电子档案详情",
                                "url": "daxq",
                                "show":false
                            },
                            {
                                "index":'5-3',
                                "path":"/daxqYz", 
                                "label": "电子档案详情",
                                "url": "daxqYz",
                                "show":false
                            },
                        ]
                    },
                    {
                        "id":'8',
                        "index":'8',
                        "path":"/xtsz", 
                        "label": "系统设置",
                        "url": "xtsz",
                        "show":true,
                        "ck":1,
                        children:[
                            {
                                "index":'8-1',
                                "path":"/yhgl", 
                                "label": "操作员管理",
                                "url": "yhgl",
                                "show":true
                            },
                            {
                                "index":'8-2',
                                "path":"/gzbm", 
                                "label": "工作部门",
                                "url": "gzbm",
                                "show":true
                            },
                            {
                                "index":'8-3',
                                "path":"/sfqx", 
                                "label": "身份权限维护",
                                "url": "sfqx",
                                "show":true
                            },
                            {
                                "index":'8-4',
                                "path":"/xtwh", 
                                "label": "系统信息维护",
                                "url": "xtwh",
                                "show":true
                            },
                            {
                                "index":'8-5',
                                "path":"/mmxg", 
                                "label": "密码修改",
                                "url": "mmxg",
                                "show":true
                            }
                        ]
                    }
                ],
                menu1:[
                    {
                       "index":'0',
                        "path":"/index", 
                        "label": "首页",
                        "url": "index",
                        "show":true,
                        "ico":"index"
                    },
                    {
                        "id":'9',
                        "index":'9',
                        "path":"", 
                        "label": "任务管理",
                        "url": "",
                        "show":true,
                        children:[
                            {
                                "index":'9-1',
                                "path":"/fbrw", 
                                "label": "发布任务",
                                "url": "fbrw",
                                "show":true
                            },
                            {
                                "index":'9-2',
                                "path":"/rwzx", 
                                "label": "任务管理",
                                "url": "rwzx",
                                "show":true
                            },
                            {
                                "index":'9-3',
                                "path":"/rwlb", 
                                "label": "领取任务",
                                "url": "rwlb",
                                "show":true
                            },
                            {
                                "index":'9-4',
                                "path":"/rwsh", 
                                "label": "审核管理",
                                "url": "rwsh",
                                "show":true
                            }
                        ]
                    },
                    {
                        "id":'10',
                        "index":'10',
                        "path":"", 
                        "label": "智能辅助办案",
                        "url": "",
                        "show":false,
                        children:[
                            {
                                "index":'10-1',
                                "path":"/znsl", 
                                "label": "一般程序辅助办案受理",
                                "url": "znsl",
                                "show":true
                            },
                            {
                                "index":'10-2',
                                "path":"/znlb", 
                                "label": "一般程序辅助办案列表",
                                "url": "znsl",
                                "show":true
                            },
                            {
                                "index":'10-3',
                                "path":"/znxq", 
                                "label": "一般程序辅助办案详情",
                                "url": "znxq",
                                "show":false
                            },
                        ]
                    },
                    {
                        "id":'1',
                        "index":'1',
                        "path":"", 
                        "label": "辅助办案管理",
                        "url": "",
                        "show":true,
                        children:[
                            {
                                "index":'1-1',
                                "path":"/ajsl", 
                                "label": "一般程序处罚案件受理",
                                "url": "ajsl",
                                "show":true
                            },
                            {
                                "index":'1-2',
                                "path":"/ajlb", 
                                "label": "一般程序处罚案件列表",
                                "url": "ajlb",
                                "show":true
                            },
                            {
                                "index":'1-4',
                                "path":"/baxq", 
                                "label": "案件详情",
                                "url": "baxq",
                                "show":false
                            },
                            {
                                "index":'1-5',
                                "path":"/baxq2", 
                                "label": "案件详情",
                                "url": "baxq2",
                                "show":false
                            }
                        ]
                    },
                    {
                        "id":'2',
                        "index":'2',
                        "path":"", 
                        "label": "智慧决策",
                        "url": "ahpc",
                        "show":true,
                        children:[
                            {
                                "index":'2-1',
                                "path":"/jcfx", 
                                "label": "决策分析",
                                "url": "jcfx",
                                "show":true
                            },
                        ]
                    },
                    {
                        "id":'3',
                        "index":'3',
                        "path":"/szpc", 
                        "label": "案中评查",
                        "url": "ahpc",
                        "show":true,
                        children:[
                            {
                                "index":'3-1',
                                "path":"/szpc", 
                                "label": "事中评查解析",
                                "url": "szpc",
                                "show":true
                            },
                            {
                                "index":'3-2',
                                "path":"/znwd", 
                                "label": "智能问答",
                                "url": "znwd",
                                "show":true
                            }
                        ]
                    },
                    {
                        "id":'4',
                        "index":'4',
                        "path":"/ahpc", 
                        "label": "案后评查",
                        "url": "ahpc",
                        "show":true,
                        children:[
                            {
                                "index":'4-1',
                                "path":"/pcpc", 
                                "label": "案卷智能解析",
                                "url": "pcaj",
                                "show":true
                            },
                            {
                                "index":'4-2',
                                "path":"/ajpc", 
                                "label": "案卷电子评查",
                                "url": "ajpc",
                                "show":true
                            },
                            //{
                            //   "index":'4-3',
                            //    "path":"/ajsc", 
                            //    "label": "案卷上传列表",
                            //    "url": "ajsc",
                            //    "show":true
                            //}
                        ]
                    },
                    
                    {
                        "id":'5',
                        "index":'5',
                        "path":"/dzda", 
                        "label": "电子档案管理",
                        "url": "dzda",
                        "show":true,
                        children:[
                            {
                                "index":'5-1',
                                "path":"/dzdak", 
                                "label": "电子档案库",
                                "url": "dzdak",
                                "show":true
                            },
                            {
                                "index":'5-2',
                                "path":"/daxq", 
                                "label": "电子档案详情",
                                "url": "daxq",
                                "show":false
                            },
                            {
                                "index":'5-3',
                                "path":"/daxqYz", 
                                "label": "电子档案详情",
                                "url": "daxqYz",
                                "show":false
                            },
                        ]
                    },
                    {
                        "id":'6',
                        "index":'6',
                        "path":"/xcws", 
                        "label": "现场执法文书管理",
                        "url": "xcws",
                        "show":true,
                        children:[
                            {
                                "index":'6-1',
                                "path":"/xcws", 
                                "label": "现场执法文书",
                                "url": "xcws",
                                "show":true
                            }
                        ]
                    },
                    {
                        "id":'7',
                        "index":'7',
                        "path":"/xdrgl", 
                        "label": "相对人管理",
                        "url": "xdrgl",
                        "show":true,
                        children:[
                            {
                                "index":'7-1',
                                "path":"/xdr", 
                                "label": "被监管对象管理",
                                "url": "xdr",
                                "show":true,
                                "label2": "相对人",
                            },
                            {
                                "index":'7-2',
                                "path":"/wdxdr", 
                                "label": "无证库",
                                "url": "wdxdr",
                                "show":true,
                                "label2": "无档相对人",
                            }
                        ]
                    },
                    {
                        "id":'8',
                        "index":'8',
                        "path":"/xtsz", 
                        "label": "系统设置",
                        "url": "xtsz",
                        "show":true,
                        children:[
                            {
                                "index":'8-1',
                                "path":"/yhgl", 
                                "label": "操作员管理",
                                "url": "yhgl",
                                "show":true
                            },
                            {
                                "index":'8-2',
                                "path":"/gzbm", 
                                "label": "工作部门",
                                "url": "gzbm",
                                "show":true
                            },
                            {
                                "index":'8-3',
                                "path":"/sfqx", 
                                "label": "身份权限维护",
                                "url": "sfqx",
                                "show":true
                            },
                            {
                                "index":'8-4',
                                "path":"/xtwh", 
                                "label": "系统信息维护",
                                "url": "xtwh",
                                "show":true
                            },
                            {
                                "index":'8-5',
                                "path":"/mmxg", 
                                "label": "密码修改",
                                "url": "mmxg",
                                "show":true
                            }
                        ]
                    }
                ],
                menu2:[
                    {
                       "index":'0',
                        "path":"/index", 
                        "label": "首页",
                        "url": "index",
                        "show":true,
                    },
                    {
                        "id":'2',
                        "index":'2',
                        "path":"", 
                        "label": "智慧决策",
                        "url": "ahpc",
                        "show":true,
                        children:[
                            {
                                "index":'2-1',
                                "path":"/jcfx", 
                                "label": "决策分析",
                                "url": "jcfx",
                                "show":true
                            },
                        ]
                    },
                    {
                        "id":'3',
                        "index":'3',
                        "path":"/szpc", 
                        "label": "案中评查",
                        "url": "ahpc",
                        "show":true,
                        children:[
                            {
                                "index":'3-1',
                                "path":"/szpc", 
                                "label": "事中评查解析",
                                "url": "szpc",
                                "show":true
                            },
                            {
                                "index":'3-2',
                                "path":"/znwd", 
                                "label": "智能问答",
                                "url": "znwd",
                                "show":true
                            }
                        ]
                    },
                    {
                        "id":'4',
                        "index":'4',
                        "path":"/ahpc", 
                        "label": "案后评查",
                        "url": "ahpc",
                        "show":true,
                        children:[
                            {
                                "index":'4-1',
                                "path":"/pcaj", 
                                "label": "案卷智能解析",
                                "url": "pcaj",
                                "show":true
                            },
                            {
                                "index":'4-2',
                                "path":"/ajpc", 
                                "label": "案卷电子评查",
                                "url": "ajpc",
                                "show":true
                            },
                            //{
                            //   "index":'4-3',
                            //    "path":"/ajsc", 
                            //    "label": "案卷上传列表",
                            //    "url": "ajsc",
                            //    "show":true
                            //}
                        ]
                    },
                    
                    {
                        "id":'5',
                        "index":'5',
                        "path":"/dzda", 
                        "label": "电子档案管理",
                        "url": "dzda",
                        "show":true,
                        children:[
                            {
                                "index":'5-1',
                                "path":"/dzdak", 
                                "label": "电子档案库",
                                "url": "dzdak",
                                "show":true
                            },
                            {
                                "index":'5-2',
                                "path":"/daxq", 
                                "label": "电子档案详情",
                                "url": "daxq",
                                "show":false
                            },
                            {
                                "index":'5-3',
                                "path":"/daxqYz", 
                                "label": "电子档案详情",
                                "url": "daxqYz",
                                "show":false
                            },
                        ]
                    },
                    {
                        "id":'8',
                        "index":'8',
                        "path":"/xtsz", 
                        "label": "系统设置",
                        "url": "xtsz",
                        "show":true,
                        children:[
                            {
                                "index":'8-1',
                                "path":"/yhgl", 
                                "label": "操作员管理",
                                "url": "yhgl",
                                "show":true
                            },
                            {
                                "index":'8-2',
                                "path":"/gzbm", 
                                "label": "工作部门",
                                "url": "gzbm",
                                "show":true
                            },
                            {
                                "index":'8-3',
                                "path":"/sfqx", 
                                "label": "身份权限维护",
                                "url": "sfqx",
                                "show":true
                            },
                            {
                                "index":'8-4',
                                "path":"/xtwh", 
                                "label": "系统信息维护",
                                "url": "xtwh",
                                "show":true
                            },
                            {
                                "index":'8-5',
                                "path":"/mmxg", 
                                "label": "密码修改",
                                "url": "mmxg",
                                "show":true
                            }
                        ]
                    }
                ],
                menu5:[
                    {
                       "index":'0',
                        "path":"/index", 
                        "label": "首页",
                        "url": "index",
                        "show":true,
                    },
                    {
                        "id":'10',
                        "index":'10',
                        "path":"", 
                        "label": "智能辅助办案",
                        "url": "",
                        "show":true,
                        children:[
                            {
                                "index":'10-1',
                                "path":"/znsl", 
                                "label": "一般程序辅助办案受理",
                                "url": "znsl",
                                "show":true
                            },
                            {
                                "index":'10-2',
                                "path":"/znlb", 
                                "label": "一般程序辅助办案列表",
                                "url": "znsl",
                                "show":true
                            },
                            {
                                "index":'10-3',
                                "path":"/znxq", 
                                "label": "一般程序辅助办案详情",
                                "url": "znxq",
                                "show":false
                            },
                        ]
                    },
                    {
                        "id":'2',
                        "index":'2',
                        "path":"", 
                        "label": "智慧决策",
                        "url": "ahpc",
                        "show":true,
                        children:[
                            {
                                "index":'2-1',
                                "path":"/jcfx", 
                                "label": "决策分析",
                                "url": "jcfx",
                                "show":true
                            },
                        ]
                    },
                    {
                        "id":'3',
                        "index":'3',
                        "path":"/szpc", 
                        "label": "案中评查",
                        "url": "ahpc",
                        "show":true,
                        children:[
                            {
                                "index":'3-1',
                                "path":"/szpc", 
                                "label": "事中评查解析",
                                "url": "szpc",
                                "show":true
                            },
                            {
                                "index":'3-2',
                                "path":"/znwd", 
                                "label": "智能问答",
                                "url": "znwd",
                                "show":true
                            }
                        ]
                    },
                    {
                        "id":'4',
                        "index":'4',
                        "path":"/ahpc", 
                        "label": "案后评查",
                        "url": "ahpc",
                        "show":true,
                        children:[
                            {
                                "index":'4-1',
                                "path":"/pcaj", 
                                "label": "案卷智能解析",
                                "url": "pcaj",
                                "show":true
                            },
                            {
                                "index":'4-2',
                                "path":"/ajpc", 
                                "label": "案卷电子评查",
                                "url": "ajpc",
                                "show":true
                            },
                            //{
                            //   "index":'4-3',
                            //    "path":"/ajsc", 
                            //    "label": "案卷上传列表",
                            //    "url": "ajsc",
                            //    "show":true
                            //}
                        ]
                    },
                    
                    {
                        "id":'5',
                        "index":'5',
                        "path":"/dzda", 
                        "label": "电子档案管理",
                        "url": "dzda",
                        "show":true,
                        children:[
                            {
                                "index":'5-1',
                                "path":"/dzdak", 
                                "label": "电子档案库",
                                "url": "dzdak",
                                "show":true
                            },
                            {
                                "index":'5-2',
                                "path":"/daxq", 
                                "label": "电子档案详情",
                                "url": "daxq",
                                "show":false
                            },
                            {
                                "index":'5-3',
                                "path":"/daxqYz", 
                                "label": "电子档案详情",
                                "url": "daxqYz",
                                "show":false
                            },
                        ]
                    },
                    {
                        "id":'7',
                        "index":'7',
                        "path":"/xdrgl", 
                        "label": "相对人管理",
                        "url": "xdrgl",
                        "show":true,
                        children:[
                            {
                                "index":'7-1',
                                "path":"/xdr", 
                                "label": "被监管对象管理",
                                "url": "xdr",
                                "show":true,
                                "label2": "相对人",
                            },
                            {
                                "index":'7-2',
                                "path":"/wdxdr", 
                                "label": "无证库",
                                "url": "wdxdr",
                                "show":true,
                                "label2": "无档相对人",
                            }
                        ]
                    },
                    {
                        "id":'8',
                        "index":'8',
                        "path":"/xtsz", 
                        "label": "系统设置",
                        "url": "xtsz",
                        "show":true,
                        children:[
                            {
                                "index":'8-1',
                                "path":"/yhgl", 
                                "label": "操作员管理",
                                "url": "yhgl",
                                "show":true
                            },
                            {
                                "index":'8-2',
                                "path":"/gzbm", 
                                "label": "工作部门",
                                "url": "gzbm",
                                "show":true
                            },
                            {
                                "index":'8-3',
                                "path":"/sfqx", 
                                "label": "身份权限维护",
                                "url": "sfqx",
                                "show":true
                            },
                            {
                                "index":'8-4',
                                "path":"/xtwh", 
                                "label": "系统信息维护",
                                "url": "xtwh",
                                "show":true
                            },
                            {
                                "index":'8-5',
                                "path":"/mmxg", 
                                "label": "密码修改",
                                "url": "mmxg",
                                "show":true
                            }
                        ]
                    }
                ],
                tags:[
                    {
                        // 默认展示首页标签，所以给予一个初始标签
                        // 每次点击菜单跳转的时候会修改数据，这样面包屑导航就可以读取到跳转时的路径，就可以显示出来，产生一个联动效果
                        "path":"/index", 
                        "label": "首页",
                        "url": "index",
                        "index":'0',
                    }
                ],
                dqMenu:'/index',
                dqActive:'0',
                fullscreen: false,
                dqOpen:0,
                yhsf:'',
                yhsfId:'',
                baseUrl:'',
                shi:''
            }
        },
        watch: {
            $route: {
                handler(route) {
                    this.menu = []
                    if( this.shi == '新乡市' ){
                        let menu = localStorage.getItem('menu')
                        if(menu != null && menu != ''){
                            this.menu = JSON.parse(menu)
                        }else{
                            this.getMenu(0,1,0)
                        }
                    }else{
                        if(this.yhsfId == '11'){
                            let menu = localStorage.getItem('menu')
                            console.log(this.yhsfId,menu,982)
                            if(menu != null && menu != ''){
                                this.menu = JSON.parse(menu)
                            }else{
                                this.getIdMenu(this.yhsfId,'sheng')
                            }
                        }else{
                            let menu = localStorage.getItem('menu')
                            if(menu != null && menu != ''){
                                this.menu = JSON.parse(menu)
                            }else{
                                this.getMenu(0,0,1)
                            }   
                        }
                    }
                    if(this.dqMenu != route.path){
                        this.dqMenu = route.path
                        console.log(this.dqActive,this.dqOpen,514)
                        if(route.path == '/index'){
                            if(route.path == '/index'){
                                this.closemenu(this.dqOpen)
                            }
                            this.dqActive = '0' 
                        }else{
                            var obj,obj2;
                            if(route.path == '/daxq' || route.path == '/daxqYz'){
                                this.dqActive = '5-1'
                            }else if(route.path == '/baxq'){
                                if(route.query.isNew == 1){
                                    this.dqActive = '1-1'
                                }else{
                                    this.dqActive = '1-2'
                                }
                            }else if(route.path == '/baxq2'){
                                if(route.query.isNew == 1){
                                    this.dqActive = '1-1'
                                }else{
                                    this.dqActive = '1-2'
                                }
                            }else if(route.path == '/znxq' && route.query.lsh){
                                this.dqActive = '10-2'
                            }else if(route.path == '/znxq' && !route.query.lsh){
                                this.dqActive = '10-1'
                            }else{
                                this.menu.forEach((item,i) => {
                                    if(item.label != '首页'){
                                        item.children.forEach(itema => {
                                            if(itema.path == route.path){
                                                this.dqActive = itema.index
                                                obj = item
                                                obj2 = itema
                                            }
                                        })
                                    }
                                })
                                this.clickMenu(obj,obj2)
                            }
                            var arr = []
                            arr.push(this.dqActive)
                            const openIndex = this.dqActive.split('-')[0] // 获取父级索引，如 '1'
                            this.handleOpen(this.dqActive, arr,openIndex)
                        }
                         
                    }
                },
                immediate: true
            }
        },
        components: {
        
        },
        computed: {
            
        },
        async created() {
            //localStorage.removeItem('menu')
            let user = JSON.parse(sessionStorage.getItem("userdata"));
            this.shi = user.shi
            this.baseUrl = user.baseUrl
            this.cmid = user.c_mid
            console.log(this.shi,this.cmid)
            this.xm = user.xm
            this.jcjg = user.jcjg
            this.yhsf = user.yhsf
            this.yhsfId = user.yhsfId
            this.menu = []
            this.dqActive = '0'
            this.dqMenu = '/index'
            let menu = localStorage.getItem('menu')
            if( this.shi == '新乡市' ){
                if(menu != null && menu != ''){
                    this.menu = JSON.parse(menu)
                }else{
                    this.getMenu(0,1,0)
                }
            }else{
                if(this.yhsfId == '11'){
                    if(menu != null && menu != ''){
                        this.menu = JSON.parse(menu)
                    }else{
                        this.getIdMenu(this.yhsfId,'sheng')
                    }
                }else{
                    if(menu != null && menu != ''){
                        this.menu = JSON.parse(menu)
                    }else{
                        this.getMenu(0,0,1)
                    }  
                }
            }
            this.yhimgurl = user.yhimgurl ? 'https://dapc1.scqwszfd.cn:8123'+user.yhimgurl : '' 
            const lastOpen = localStorage.getItem('lastOpenMenu')
            console.log(lastOpen)
            if (lastOpen) {
                this.dqActive = lastOpen + '-1' // 假设子菜单为 -1
                this.handleOpen(lastOpen, [lastOpen])
            }  
        },
        mounted() {
        },
        methods: {
            getMenu(val,val2,val3){
                console.log(val,val2,val3,1144)
                axios({
                    method: 'post',
                    url: this.baseUrl+`/pdfApi/menuList`,
                    headers: { // 添加请求头
                        "Content-Type": "application/json" // 明确声明为 JSON 格式
                    },
                    data: {
                        isYz:val==1?1:'',
                        isXx:val2==1?1:'',
                        isSc:val3==1?1:''
                    }
                })
                .then(response => {
                    console.log(response.data,1140);
                    let obj = {
                    "index":'0',
                        "path":"/index", 
                        "label": "首页",
                        "url": "index",
                        "show":true,
                        "ico":"index"
                    }
                    let arr = response.data.data
                    .filter(item => item.item !== '展示页' ) // 先过滤
                    .map((item, idx) => ({
                        ...item,
                        index: item.children && item.children[0].indexs
                            ? String(item.children[0].indexs.split('-')[0]) 
                            : String(idx),
                        label: item.item,
                        show: true,
                        children: item.children.filter(child => child.label !== '发布任务' && child.label !== '任务管理' && child.label !== '审核管理' && child.label !== '省案卷同步').map((child, i) => ({
                            
                                ...child,
                                path: child.paths,
                                ck: 1,
                                index: child.indexs 
                                    ? String(child.indexs) 
                                    : `${item.index || idx}-${i}`
                            
                        })) 
                    }));
                    console.log(arr,1184)
                    const sortedOrder = val2 ==1 ? [4, 2, 3, 0, 1] :(val == 1 ? [4,5,3,1,0,2] : [7,0,2,6,3,1,4,5]) ; // 让 arr[0] 出现在第4位
                    const sortedMenu = sortedOrder
                    .map(i => arr[i])
                    .filter(Boolean); // 去除 undefined 或 null

                    this.menu = [obj, ...sortedMenu];
                    console.log(this.menu,'目录')
                    localStorage.setItem('menu', JSON.stringify(this.menu))
                    this.getIdMenu(this.yhsfId)
                })
                .catch(error => {
                    console.error('There was an error!', error);
                });
            },
            getIdMenu(yhsfId,val){
                axios({
                    method: 'post',
                    url: this.baseUrl+`/login/getIDSee`, 
                    data:{
                        id: yhsfId,
                    },
                    headers: { 
                        "Content-Type": "application/json"
                    },
                }).then(res => {
                    console.log(res,852)
                    if(res.data.code == 0){
                        this.qxList = res.data.data || []
                        sessionStorage.setItem("quxiandata", JSON.stringify(this.qxList));
                        if(val == 'sheng'){
                            this.menu = [
                                {
                                "index":'0',
                                    "path":"/index", 
                                    "label": "首页",
                                    "url": "index",
                                    "show":true,
                                }
                            ]
                            // 遍历 qxList，整理成 menu 的结构
                            const parentMap = {} // 用于存储父菜单项，避免重复
                            this.qxList.forEach(entry => {
                                if (entry.ck) {
                                // 父菜单项标识
                                const parentLabel = entry.item_qz
                                const parentId = entry.indexs.split('-')[0] || this.menu.length

                                // 如果该父菜单还未创建，则创建
                                if (!parentMap[parentLabel]) {
                                    parentMap[parentLabel] = {
                                    index: parentId,
                                    label: parentLabel,
                                    show: true,
                                    children: []
                                    }
                                    this.menu.push(parentMap[parentLabel])
                                }

                                // 添加子菜单项
                                parentMap[parentLabel].children.push({
                                    index: entry.indexs,
                                    path: entry.paths,
                                    label: entry.item,
                                    url: entry.paths,
                                    show: entry.show,
                                    ck: entry.ck,
                                    xg: entry.xg,
                                    sc: entry.sc,
                                    xz: entry.xz
                                })
                                }
                            })

                            console.log(this.menu, 1128)
                            localStorage.setItem('menu', JSON.stringify(this.menu))
                            const lastOpen = localStorage.getItem('lastOpenMenu')
                            console.log(lastOpen)
                            if (lastOpen) {
                                this.dqActive = lastOpen + '-1' // 假设子菜单为 -1
                                this.handleOpen(lastOpen, [lastOpen])
                            }     
                        }           
                    }
                })
            },
            // 其他方法...
            navigateToHome() {
                    window.open('https://xxswj-dash.hzxhykj.com', '_blank');
            },
            handleSelect(){
                this.dqMenu = this.$route.path
                console.log(this.dqActive,this.dqMenu)
            },
            clickMenu(item,itema){
                console.log(item,itema,1230)
                this.$router.push({path:itema.path})
                this.dqMenu = itema.path
                if(itema.path == '/ajlb'){
                    this.dqActive = '1-2'
                    this.dqOpen = 1
                }else{
                    this.dqOpen = itema.index.split('-')[0]
                    this.dqActive = itema.index
                }
                
                console.log(this.dqMenu,this.dqActive,1176)
                let isY = this.tags.some(ele => {
                    return ele.path == itema.path
                })
                console.log(isY)
                if(!isY){
                    this.tags.push(itema)
                    console.log(this.tags)
                }
            },
            clickMenu2(){
                this.$router.push({path:'/index'})
                this.dqMenu = '/index'
                this.dqActive = '0'
                console.log(this.dqOpen)
                this.closemenu(this.dqOpen)
            },
            changeMenu(tag){
                this.dqMenu = tag.path
                this.dqActive = tag.index
                if(tag.path != '/index'){
                    this.dqOpen = tag.index.split('-')[0]
                }
                this.$router.push({
                    path: tag.path
                })
                console.log(this.dqOpen)
                this.$forceUpdate()
                if(tag.path == '/index'){
                    this.closemenu(this.dqOpen)
                }
                // this.dqMenu = this.menu.findIndex(item => {
                //     return item.path == tag.path
                // }) + ''
            },
            toHome(){
                this.$router.push("/")
            },
            editPass(){
                this.$router.push("/mmxg")
            },
            handleOpen(key, keyPath) {
                console.log(key, keyPath,1263)
                // if(key.indexOf('-') != -1){
                //     .slice(0,1)
                // }
                this.dqActive = key + ''
                console.log(this.dqActive)
                this.dqOpen = key
                console.log(this.dqOpen)
                localStorage.setItem('lastOpenMenu', key)

            },
            closemenu(index){
                this.$refs.menu.close(index)
            },
            handleCloseC(key, keyPath) {
                console.log(key, keyPath)
            },
            handleClose(tag,index){
                // 当前tags总的length是遍历完成后数组中对象的个数，默认肯定是为1，因为首页标签一直都在
                // tag标签当前的index和长度的关系是一个减一的关系，因为索引是从0开始嘛。
                // 如果这两个值相等，就表明当前我们点击的是最后一个tag标签，则事件触发后跳转到左侧的标签
                if(tag.path == this.$route.path ){
                    this.tags.splice(index,1)
                    this.$router.push({
                        path: this.tags[index - 1].path
                    })
                    this.dqActive = (index - 1) + ''
                    // 如果不相等，即只有一种可能性，即当前事件触发的索引不是最后一个，且只会是中间的，那么就跳转到右侧正序的标签
                }else {
                    this.tags.splice(index,1)
                }
            },
            logout(){
                this.$confirm('确定注销并退出系统吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    sessionStorage.removeItem('userdata')
                    this.$router.push("/login")
                })
            },
            screenFull(){
                const element = document.documentElement
                if (this.fullscreen) {
                    if (document.exitFullscreen) {
                        document.exitFullscreen()
                    } else if (document.webkitCancelFullScreen) {
                        document.webkitCancelFullScreen()
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen()
                    } else if (document.msExitFullscreen) {
                        document.msExitFullscreen()
                    }
                } else {
                    if (element.requestFullscreen) {
                        element.requestFullscreen()
                    } else if (element.webkitRequestFullScreen) {
                        element.webkitRequestFullScreen()
                    } else if (element.mozRequestFullScreen) {
                        element.mozRequestFullScreen()
                    } else if (element.msRequestFullscreen) {
                        // IE11
                        element.msRequestFullscreen()
                    }
                }
                this.fullscreen = !this.fullscreen
            }
        }
    }
</script>

<style scoped>
.box{ position: relative; width: 100vw; height: 100vh;}
.top{width: 100%; height:123px; overflow: visible;background: #2764D0;}
.left img{ float: left;margin: 26px 15px 25px 23px; width: auto; height: 70px;}
.left span{ color: #fff; font-size: 22px; margin-top: 54px; float: left; letter-spacing: 2px;}
.top h1{font-size: 36px;line-height: 123px; float: left; color:#fff; font-weight: bold; font-family: 'shuzi'; letter-spacing: 2px;}
.right{float: right;margin: 27px 15px 0 25px;}
.right .btn{float: right; text-align: center; color: #fff; width: 50px;margin-top: 15px;}
.right .tet{min-width: 230px; text-align: right;  float: right;padding:0 15px; line-height: 25px;height:70px;color: #eaf4ff;}
.right .tet img{float: left; margin-right: 15px;  width: 70px;  height: 70px; border-radius: 40px;}
.right .btn2{width: 80px;}
.right .tet p{float: left; text-align: left; padding-top: 10px; font-size: 14px;}
.right .tet p *{ display: block; width: 100%;}
.right .tet p label{opacity: 0.5;}
.right >>> .el-dropdown{float: right;}
.right >>> .el-dropdown p{float: left; margin:39px 10px; width: 42px; height:42px;border-radius: 2px; background: #cadef6; overflow: hidden;}
.right .btn img{ width: 18px;padding:0 16px; cursor: pointer;}
.right .btn2 img{padding:0 31px;}
.right .btn span{ width: 100%; display: block; font-size: 12px; padding-top: 4px;}
.line{float: right; width: 1px; height: 60px; margin:5px 0; background: rgba(255, 255, 255, 0.1);}
.light{ width: 100%; text-align: center; position: absolute; top:0;}
.btm{ width:100vw; height: calc(100vh - 123px); position: absolute; top:123px; z-index: 10; overflow: hidden;}
.nav{ overflow:hidden;   height: calc(100vh - 123px);position: absolute;top:123px;left: 0; box-shadow: 0 5px 10px rgb(0 21 41 / 8%); z-index: 1;}
.nav >>> .el-scrollbar { width: 100%; height: 100%;}
.nav >>> .el-scrollbar__bar.is-horizontal{opacity: 0;}
.nav >>> .el-scrollbar__wrap { overflow-y: auto !important; overflow-x: hidden;}
.nav >>> .el-scrollbar__view{min-height: 100%;}
.nav >>> .el-scrollbar__view{ background: #eef3f9;}

.main{ position: absolute; top:123px;bottom: 0;overflow-y: auto;    right: 0;}
.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 220px;
    min-height: 400px;
}
.nav >>> .el-menu { border-right: none;height: 100%;}
.nav >>> .el-submenu .el-menu--inline{width: 100%;border-bottom: 1px solid #e1eaf3;margin-left: -6px; border-left: none;}
.nav >>> .el-menu-item,.nav >>> .el-submenu{width: calc(100% - 6px); border-left: solid 6px #fff;width: 100%;}
.nav >>> .el-submenu .el-menu-item{background:#f3f9ff !important; border-left: none; padding-left: 58px !important; height: auto;}
.nav >>> .el-submenu .el-menu-item p{ height: 50px; line-height: 50px; min-width: 200px;}
.nav >>> .el-menu i.ico {width:20px;height:20px;float: left; margin:18px 12px 0 0;}
.nav >>> div:nth-child(2) li i.ico{background: url(../../assets/images/icon/index.png) no-repeat center center;}
.nav >>> div:nth-child(3) li i.ico{background: url(../../assets/images/icon/fzba.png) no-repeat center center;}
.nav >>> div:nth-child(4) li i.ico{background: url(../../assets/images/icon/info.png) no-repeat center center;}
.nav >>> div:nth-child(5) li i.ico{background: url(../../assets/images/icon/upload.png) no-repeat center center;}
.nav >>> div:nth-child(6) li i.ico{background: url(../../assets/images/icon/dzda.png) no-repeat center center;}
.nav >>> div:nth-child(7) li i.ico{background: url(../../assets/images/icon/book.png) no-repeat center center;}
.nav >>> div:nth-child(8) li i.ico{background: url(../../assets/images/icon/info.png) no-repeat center center;}
.nav >>> div:nth-child(9) li i.ico{background: url(../../assets/images/icon/xdr.png) no-repeat center center;}
.nav >>> .el-submenu__title i.ico{background: url(../../assets/images/icon/set.png) no-repeat center center;}

.nav2 >>> div:nth-child(2) li i.ico{background: url(../../assets/images/icon/index.png) no-repeat center center;}
.nav2 >>> div:nth-child(3) li i.ico{background: url(../../assets/images/icon/info.png) no-repeat center center;}
.nav2 >>> div:nth-child(4) li i.ico{background: url(../../assets/images/icon/upload.png) no-repeat center center;}
.nav2 >>> div:nth-child(5) li i.ico{background: url(../../assets/images/icon/dzda.png) no-repeat center center;}
.nav2 >>> div:nth-child(6) li i.ico{background: url(../../assets/images/icon/book.png) no-repeat center center;}
.nav2 >>> div:nth-child(7) li i.ico{background: url(../../assets/images/icon/set.png) no-repeat center center;}
.nav >>> .el-menu-item:focus,.nav >>> .el-menu-item:hover,.nav >>> .el-submenu:focus,.nav >>> .el-submenu:hover  { outline: 0; background-color: #e8f3fd; border-left: solid 6px #e8f3fd;}
.nav >>> .el-menu-item.is-active,.nav >>> .el-submenu.is-active { font-weight: bold; background: #e7f3ff; border-left: solid 6px #1890ff;}
.nav >>> .el-submenu .el-menu-item:focus,.nav >>> .el-submenu .el-menu-item:hover { outline: 0; background-color: #e8f3fd !important; border-left: none;}
/* .nav >>> .el-submenu.is-active .el-menu{ display: block !important;} */
.nav >>> .el-submenu .el-menu-item.is-active2 { font-weight: bold; background-color: #fff; color:#1890ff; border-left:none !important;}
.navA{display: block;height: 50px; line-height: 50px; padding-left: 58px;width: 100%; background: #f3f9ff ;color: #303133; border-left: none;}
.navA:hover { outline: 0; background-color: #e8f3fd !important; border-left: none;}
.tags{position: fixed;z-index: 2;width: 100%; height: 33px; background: #e4e9ed; box-shadow: 0 2px 5px rgb(36 36 36 / 8%); margin-bottom: 20px;border-bottom: 1px solid #d8dce5;}
.tags >>> .el-radio-button__inner{border:none; outline: none; height: 100%;}

.tags >>> .el-radio-button{height: 33px;}
.tags >>> .el-radio-button__inner{padding:8px 10px; background: #f3f3f3;}
.tags >>> .el-tag{margin-left: 10px; margin-top: 4px; border-radius: 0; cursor: pointer;}
.mainContent{width:calc(100% - 40px);min-height: calc(100% - 73px);background: #F2F5F6; padding:20px;margin-top: 33px;}

.nav >>> .el-submenu{border-left: solid 6px #fff;}
</style>